import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 8px;
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #d5d5d5;
  border-radius: 16px;
  width: 122px;
  height: 105px;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
`;

export const LargeText = styled.p`
  color: var(--Cinza-Black, #000);
  text-align: center;
  font-family: Inter;
  font-size: 26.341px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.263px;
`;

export const Text = styled.p`
  color: var(--Cinza-Gray-400, #424248);
  text-align: center;
  font-family: Inter;
  font-size: 14.268px;
  font-style: normal;
  font-weight: 500;
  line-height: 15.366px; /* 107.692% */
  letter-spacing: -0.143px;
`;
